import { createFileRoute } from "@tanstack/react-router";
import { ReviewsContainer } from "@/features/reviews";

export const Route = createFileRoute("/$store/_layout/reviews")({
	component: ReviewsPage,
});

function ReviewsPage() {
	return <ReviewsContainer />;
}
